<template>
    <div class="matchDetail">
        <Header></Header>
        <div class="matchContent">
            <div class="matchContent_title">
                <el-carousel trigger="click">
                    <el-carousel-item v-for="item in matchData.pictureList" :key="item">
                        <img style="width: 100%" :src="item" alt="">
                    </el-carousel-item>
                </el-carousel>
                <div class="matchContent_tab">
                    <div class="container matchContent_tab_box">
                        <template v-for="(item, index) in tabList">
                            <div
                                :key="index"
                                :class="tabActive == item.text? 'matchContent_tab_item active' : 'matchContent_tab_item'"
                                v-if="matchData[item.name]||item.name=='works'||item.name=='upload'"
                                @click="changeTab(item.text)">
                                    <div class="icon_box">
                                        <img :src="item.icon" alt="">
                                    </div>
                                    <span>{{ item.text }}</span>
                                </div>
                        </template>
                    </div>
                </div>
            </div>
            <div class="container matchContent_content">
                <span class="matchContent_content_title">{{ `- ${tabActive} -` }}</span>
                <div v-show="tabActive == '报名通道'" v-html="matchData.applyWay">
                </div>
                <div v-show="tabActive == '大赛介绍'" v-html="matchData.introduce">
                </div>
                <div v-show="tabActive == '大赛规则'" v-html="matchData.rule">
                </div>
                <div v-show="tabActive == '大赛奖励'" v-html="matchData.award">
                </div>
                <div class="worksListBox" v-show="tabActive == '参赛作品'">
                    <div class="worksListBox_box" v-if="worksList.length">
                        <div
                         class="match_works"
                         v-for="(item, index) in worksList"
                         :key="index"
                         @click="$router.push(`matchWorks/${item.id}`)">
                            <img class="works_cover" :src="item.cover? item.cover : item.workPictureList[0]" alt="">
                            <div class="works_info">
                                <img class="user_avatar" :src="item.authorAvatar" alt="">
                                <span class="user_authorName">{{ item.authorName }}</span>
                                <span class="works_name">{{ item.name }}</span>
                            </div>
                        </div>
                        <el-pagination
                         background
                         layout="total, prev, pager, next"
                         :total="totalElements"
                         :page-size="8"
                         @current-change="changePagination">
                        </el-pagination>
                    </div>
                    <span v-if="!worksList.length" class="default">
                        <img src="@/assets/icon/notdata.png" alt="">
                        暂时没有相关数据
                    </span>
                </div>
                <div v-if="tabActive == '作品上传' && (userInfo && JSON.stringify(userInfo) != '{}')">
                    <el-form v-if="!signUpSuccess" :model="ruleForm" :rules="rules" ref="ruleForm" size="medium" label-width="100px" class="demo-ruleForm">
                        <el-form-item label="赛项" prop="matchItemId">
                            <el-select
                             v-model="ruleForm.matchItemId" 
                             placeholder="请选择参赛赛项"
                             @change="handlerMatchItem">
                                <el-option
                                 v-for="(item, index) in matchItem"
                                 :key="index"
                                 :label="item.name" 
                                 :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="组别" prop="matchItemGroupId">
                            <el-select :disabled="!ruleForm.matchItemId" v-model="ruleForm.matchItemGroupId" placeholder="请选择参赛组别">
                                <el-option
                                 v-for="(item, index) in matchItemGroup"
                                 :key="index"
                                 :label="item.name" 
                                 :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="名称" prop="name">
                            <el-input v-model="ruleForm.name" placeholder="请填写作品名称"></el-input>
                        </el-form-item>
                        <el-form-item label="视频" prop="workVideoUrl">
                            <el-upload
                             :action="avatarUploadUrl"
                             drag
                             :headers="headers"
                             :limit="1"
                             :before-upload="beforeVideoUpload"
                             :on-success="handlerVideoSuccess"
                             :on-remove="handleRemove">
                                <i class="el-icon-upload"></i>
                                <div class="el-upload__text">将视频文件拖到此处，或<em>点击上传</em></div>
                                <div class="el-upload__tip" slot="tip">只能上传一个视频文件，且不超过500MB</div>
                            </el-upload>
                        </el-form-item>
                        <el-form-item label="图片" prop="workPictureList">
                            <CardUpload @change="changeImg"></CardUpload>
                        </el-form-item>
                        <el-form-item label="说明文档：" prop="documentUrls">
                            <clickUpload
                                @change="docsUpload"
                                @removed="removeDoc"
                                :limit="3"
                                listType="text"
                                :drag="true"
                                :uploadSize="50"
                                ref="docUploader"
                                accept=".doc, .docx, .pdf, .ppt, .pptx"
                                :uploadPath="`/uploadCourseware`"
                                noticeText="只能上传doc/docx/pdf/ppt/pptx文件，且不超过50MB"
                            />
                        </el-form-item>
                        <el-form-item>
                            <loadingBtn btnText='提交' @click="submitForm('ruleForm')"/>
                        </el-form-item>
                    </el-form>
                    <div v-else class="signUpSuccess">
                        <div class="signUpSuccessTitle">恭喜您，参赛成功</div>
                        <div class="signUpSuccessFooter">
                            <el-link type="primary" @click="signUpSuccess=false">继续报名</el-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Header from '@/components/header';
import matchApi from '@/request/api/match';
import communityApi from '@/request/api/community';
import fileApi from '@/request/api/file';
import userApi from '@/request/api/user';
import Operation from "@/request";
import CardUpload from '@/components/upload/cardUpload';
import clickUpload from "@/components/upload/clickUpload";
import loadingBtn from "@/components/btns/loadingBtn"

export default {
    components: { Header, CardUpload ,clickUpload,loadingBtn},
    computed: {
        themeData() {
            return this.$store.state.themeData;
        },
        userInfo() {
            return this.$store.state.userInfo;
        },
    },
    data() {
        return {
            matchId: "",
            matchData: "",
            tabActive: "大赛介绍",
            tabList: [{
                icon: require('@/assets/match/presentation.png'),
                text: "大赛介绍",
                name:'introduce'
            },{
                icon: require('@/assets/match/apply.png'),
                text: "报名通道",
                name:'applyWay'
            }, {
                icon: require('@/assets/match/rule.png'),
                text: "大赛规则",
                name:'rule'
            }, {
                icon: require('@/assets/match/award.png'),
                text: "大赛奖励",
                name:'award'
            }, {
                icon: require('@/assets/match/works.png'),
                text: "参赛作品",
                name:'works'
            }, {
                icon: require('@/assets/match/upload.png'),
                text: "作品上传",
                name:'upload'
            }],
            worksList: [],
            totalElements: 0,
            pageNum: 1,
            ruleForm: {
                name: '',
                matchItemId: '',
                matchItemGroupId: '',
                workVideoUrl: "",
                workPictureList: [],
                documentUrls:[]
            },
            rules: {
                name: [
                    { required: true, message: '请填写作品名称', trigger: 'change' },
                ],
                matchItemId: [
                    { required: true, message: '请选择赛项', trigger: 'change' }
                ],
                matchItemGroupId: [
                    { required: true, message: '请选择组别', trigger: 'change' }
                ],
                workVideoUrl: [
                    { required: true, message: '请上传作品解说视频', trigger: 'change' }
                ],
                workPictureList: [
                    { required: true, message: '请上传作品相关图片', trigger: 'change' }
                ],
                documentUrls: [
                    { required: true, message: '请上传作品说明文档', trigger: 'change' }
                ]
            },
            matchItem: [],
            matchItemGroup: [],
            dialogImageUrl: "",
            headers: { token: this.uploadGetToken() },
            signUpSuccess:false,
        }
    },
    watch: {
        userInfo() {
            if(this.userInfo) {
                this.uploadGetToken();
            }
        },
    },
    created() {
        this.getAvatarUploadUrl();
        this.getMatchData();
    },
    methods: {
        //拼接头像上传地址
        getAvatarUploadUrl(){
            this.avatarUploadUrl = Operation.Const.ApiUrl+"/upload";
        },
        //获取token
        uploadGetToken() {
            if(userApi.getToken()) {
                let tokenId = userApi.getToken();
                return tokenId;
            }
        },
        //获取赛事数据
        getMatchData() {
            if(this.$route.query && this.$route.query.id) {
                this.matchId = this.$route.query.id;
                matchApi.matchDetail(this.matchId, res => {
                    if(res.succeed) {
                        this.matchData = res.data;
                    }
                })
            }
        },
        changeTab(text) {
            if(text == '作品上传') {
                if(this.matchData.status == '过期') {
                    this.$message({
                        message: '当前赛事已经结束',
                        type: 'warning'
                    });
                    return;
                } else if(!this.userInfo || JSON.stringify(this.userInfo) == "{}") {
                    this.$store.commit('setDialogVisible', true);
                    return;
                }
                this.getMatchItem();
            } else if(text == '参赛作品') {
                this.getworksList();
            }
            this.tabActive = text;
        },
        //获取作品列表
        getworksList() {
            let params = {
                name: this.search,
                pageNumber: this.pageNum,
                pageSize: 8,
                sortDirection: 1,
                sortName: "",
                status: "已发布",
                institutionId: this.themeData.id,
                matchId: this.matchId,
                matchItemId: "",//所属赛项
                allType: "1", //给全部类型作品
            }
            communityApi.worksListByType(params, res => {
                if(res.succeed) {
                    this.worksList = res.data.content;
                    this.totalElements = res.data.totalElements;
                }
            })
        },
        //分页切换
        changePagination(val) {
            this.pageNum = val;
            this.getworksList();
        },
        //获取赛项
        getMatchItem() {
            matchApi.matchItemSelectList(this.matchId, res => {
                if(res.succeed) {
                    this.matchItem = res.data;
                }
            })
        },
        //获取组别
        getMatchItemGroup(id) {
            matchApi.matchItemGroupSelectList(id, res => {
                if(res.succeed) {
                    this.matchItemGroup = res.data;
                }
            })
        },
        handlerMatchItem(value) {
            this.getMatchItemGroup(value);
            this.ruleForm.matchItemGroupId=''
        },
        //视频文件上传验证
        beforeVideoUpload(file) {
            if(!file.type.endsWith('mp4')) {
                this.$message({
                    message: '请上传mp4格式的视频文件',
                    type: 'warning'
                });
                return false;
            }
            if(file.size > 314572800) {
                this.$message({
                    message: '请上传小于300M的视频文件',
                    type: 'warning'
                });
                return false;
            }
        },
        //上传视频文件
        handlerVideoSuccess(response, file, fileList) {
            if(response) {
                this.ruleForm.workVideoUrl = response;
            }
            this.$refs.ruleForm.validateField('workVideoUrl')
        },
        //操作文件列表
        handleRemove(file, fileList) {
            if(file.response) {
                fileApi.deleteFile(file.response, res => {
                    if(res.succeed) {
                        this.ruleForm.workVideoUrl = "";
                    }
                })
            }
        },
        //上传图片
        changeImg(list) {
            this.ruleForm.workPictureList = list;
            this.$refs.ruleForm.validateField('workPictureList')
        },
        //提交信息
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.$store.dispatch('loading/startLoading')
                    let params = {
                        matchId: this.matchId,
                        institutionId: this.themeData.id,
                        status: "已发布",
                        ...this.ruleForm
                    };
                    communityApi.applyWorks(params, res => {
                        if(res.succeed) {
                            this.$message({
                                message: '报名成功！',
                                type: 'success'
                            });
                            this.signUpSuccess=true
                            this.clearForm()
                        }
                    })
                } else {
                    return false;
                }
            });
        },
        docsUpload(res){
            this.ruleForm.documentUrls.push(res.data)
            this.$refs.ruleForm.validateField('documentUrls')
        },
        removeDoc(file){
            fileApi.deleteCourseware(file.response.data,res=>{
                if(res.succeed){
                    let index=this.ruleForm.documentUrls.findIndex(item=>{
                        return item==file.response.data
                    })
                    index!=-1&&this.ruleForm.documentUrls.splice(index,1)
                    this.$message({
                        message: '删除成功',
                        type: 'success'
                    });
                }
            })
        },
        clearForm(){
            this.$refs.ruleForm.resetFields();
            this.ruleForm= {
                name: '',
                matchItemId: '',
                matchItemGroupId: '',
                workVideoUrl: "",
                workPictureList: [],
                documentUrls:[]
            }
        },
        
    },
}
</script>
<style lang="scss">
.matchDetail {
    input[type="file"] {
        display: none;
    }
    .el-select {
        display: block;
    }
    font-family: Source Han Sans CN;
    background-color: #F3F5F7;
    .matchContent_title {
        width: 100%;
    }
    .el-carousel__container {
        height: calc(100vw/16*3);
    }
    .matchContent_tab {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        width: 100%;
        background-color: #fff;
    }
    .matchContent_tab_box {
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        align-items: center;
        background-color: #fff;
    }
    .matchContent_tab_item {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 100px;
        height: 100px;
        cursor: pointer;
        user-select: none;
    }
    .matchContent_tab_item img {
        width: 100%;
        opacity: .5;
    }
    .matchContent_tab_item span {
        display: block;
        color: #0381D6;
        font-size: 15px;
        opacity: .5;
    }
    .matchContent_tab_item.active img,
    .matchContent_tab_item.active span {
        opacity: 1;
    }
    .matchContent_tab_item.active span {
        text-shadow: 0px 6px 5px rgba(3, 129, 214, .5);
    }
    .icon_box {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        width: 60px;
        height: 60px;
        padding: 5px;
    }
    .matchContent_content {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        padding: 30px;
        min-height: 500px;
        margin: 50px auto;
        background-color: #fff;
    }
    .matchContent_content_title {
        display: block;
        width: 280px;
        height: 100px;
        color: #fff;
        font-size: 26px;
        font-weight: 600;
        text-align: center;
        line-height: 100px;
        margin-bottom: 25px;
        background-image: url(~@/assets/match/title.png);
        background-size: cover;
        background-repeat: no-repeat;
        user-select: none;
    }
    .worksListBox {
        display: flex;
        flex-flow: row wrap;
        justify-content: flex-start;
        align-items: center;
        width: 100%;
        padding: 20px 0;
        border-radius: 5px;
    }
    .worksListBox_box {
        display: flex;
        flex-flow: row wrap;
        justify-content: flex-start;
        align-items: center;
        width: 100%;
    }
    .worksListBox .match_works {
        display: flex;
        flex-direction: column;
        width: 25%;
        padding: 0 1%;
        color: var(--theme-color);
        font-size: 15px;
        font-weight: 600;
        margin: 10px 0;
        transition: all .2s linear 0s;
        cursor: pointer;
    }
    .worksListBox .match_works:hover {
        box-shadow: 0 10px 15px rgba(0, 0, 0, .1);
        transform: translate3d(0px,-2px,0px);
    }
    .match_works .works_cover {
        max-width: 100%;
        height: 174px;
    }
    .match_works .works_info {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        padding: 7px 0;
    }
    .match_works .user_avatar {
        width: 28px;
        height: 28px;
        border-radius: 50%;
    }
    .match_works .user_authorName {
        display: inline-block;
        padding: 0 5px;
    }
    .match_works .works_name {
        display: inline-block;
        padding: 0 5px;
    }
    .el-pagination {
        display: flex;
        justify-content: center;
        width: 100%;
        margin-top: 50px;
    }
    .demo-ruleForm {
        width: 650px;
    }
    .default  {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 100%;
        padding-top: 50px;
        color: #8a8a8a;
        font-size: 15px;
    }
    .default  img {
        width: 80px;
    }
    .signUpSuccess{
        .signUpSuccessTitle{
            color: #0DBC79;
            text-align: center;
            font-size: 50px;
            padding: 40px 0 20px;
        }
        .signUpSuccessFooter{
            text-align: center;
            padding: 40px 0;
        }
    }
    @media (max-width: 768px) {
        .worksListBox .match_works {
            width: 50%;
        }
    }
    @media (max-width: 767px){
        .matchContent_tab_box {
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            justify-content: center;
            align-items: center;
            align-content: flex-start;
            background-color: #fff;
        }
        .worksListBox .match_works {
            width: 100%;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/views/match/matchDetail.vue